<template>
  <div>
    <div
        v-if="loading"
        class="flex flex-col justify-center items-center h-full mt-5 w-full"
    >
      <el-loading :text="'Loading...'" />
    </div>
    <div v-else>
      <div class="p-2">
        <ve-table :columns="columns" :table-data="feedback" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "360dGoals",
  created() {
    this.getPerformancePeriods()

  },
  data() {
    return {
     feedback:[],
      loading:false,
      ReviewPeriodIds: [],
      reviewPeriod:"",
      columns: [
        {
          field: "Question",
          key: "a",
          title: "Competency Area",
        },
        { field: "PeriodName", key: "b", title: "Review Period" },
        {
          field: "AverageRating",
          key: "xx",
          title: "Average",
        },
      ],
    };
  },
  methods:{
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
             this.reviewPeriod = response.data.Data[0].Id
              this.getFeedback()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    getFeedback(){
      console.log(this.reviewPeriod)
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/feedback/${this.$ApiVersion}/mine`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params: {
          periodId: this.reviewPeriod,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.feedback = response.data.Data;
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: 'Failure', message: error.message });
          }
      );
    }
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
  }
};
</script>
